module.exports = __webpack_public_path__ + "img/svg/arrow-right.63f119a4dcdaf1fc2715c2051ec10848.svg";